// factory function, not to be confused with batws.js which is not (see module.fad.js)
import RestAPI from 'lib/rest';

var spec = {
  host: '/config',
  apis: {
    'inventory': {
      url: '/services/inventory/search/',
      calls: {
        getInventory: {
          url: 'getInventory',
          method: 'POST',
          stringify: true,
          dataType: 'json',
          contentType: 'application/json',
          defaults: {
            brand: 'TOY',
            filter: {
              year: [2018],
              series: ['camry'],
              dealers: [],
              region: [],
              grade: [],
              cab: [],
              bed: [],
              exteriorcolor: [],
              interiorcolor: [],
              accessory: [],
              packages: [],
              engine: [],
              transmission: [],
              andfields: ['accessory','packages','exteriorcolor','grade'],
              model: []
            },
            fields: [],
            facetfields: [],
            sortfield: 'MSRP',
            sortorder: 'ASC',
            pagesize: null,
            pagestart: 0,
            group: 'true',
            groupmode: 'full',
            mode: 'content'
          }
        }
      }
    }
  }
};

export default new RestAPI(spec);
